import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box } from 'src/components/UI'
import { getProsFilter } from 'src/ducks/filters/selector'
import { PROS_PAGE_STATUS } from 'src/helpers'
import InsuranceDashboard from './InsuranceDashboard'
import Dashboard from './LicenseDashboard'
import ProsDashboard from './ProsDashboard'

const Pros: FC = () => {
  const prosFilter = useSelector(getProsFilter())

  const [pageStatus, setPageStatus] = useState<PROS_PAGE_STATUS>(
    prosFilter.pageStatus ?? PROS_PAGE_STATUS.PROS
  )

  useEffect(() => {
    setPageStatus(prosFilter.pageStatus ?? PROS_PAGE_STATUS.PROS)
  }, [prosFilter])

  return <Box>
    {pageStatus === PROS_PAGE_STATUS.PROS && <ProsDashboard />}
    {pageStatus === PROS_PAGE_STATUS.LICENSES && <Dashboard />}
    {pageStatus === PROS_PAGE_STATUS.INSURANCE && <InsuranceDashboard />}
  </Box>
}

export default Pros
